import { Image } from '@change/ds-core-ui';

import { ResponsiveMedia } from '../ResponsiveMedia';

type ImpactImageProps = Readonly<{
	image: string;
	title: string;
	view: 'mobile' | 'desktop';
}>;

export const ImpactImage: React.FC<ImpactImageProps> = ({ image, title, view }) => {
	return (
		<ResponsiveMedia view={view} kind="image">
			<Image
				src={image}
				data-testid="impact-story-image"
				className="md:rounded-large h-full w-full rounded-none object-cover"
				alt={title}
			/>
		</ResponsiveMedia>
	);
};
